import { configureStore } from "@reduxjs/toolkit"

import {
  alert,
  auth,
  cs,
  hrc,
  orders,
  thinkific,
} from "./reducers";

const store = configureStore({
  reducer: {
    alert,
    auth,
    cs,
    hrc,
    orders,
    thinkific,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
});

export default store;